import {
    NEWSLETTER_CREATE_REQUEST,
    NEWSLETTER_CREATE_SUCCESS,
    NEWSLETTER_CREATE_FAIL,
    NEWSLETTER_LIST_REQUEST,
    NEWSLETTER_LIST_SUCCESS,
    NEWSLETTER_LIST_FAIL,
    NEWSLETTER_DELETE_REQUEST,
    NEWSLETTER_DELETE_SUCCESS,
    NEWSLETTER_DELETE_FAIL,
    NEWSLETTER_DELETE_ALL_REQUEST,
    NEWSLETTER_DELETE_ALL_SUCCESS,
    NEWSLETTER_DELETE_ALL_FAIL
} from '../actions/newsletter';

const initialState = {
    newsletters: [],
    loading: false,
    error: null,
    success: false
};

const newsletterReducer = (state = initialState, action) => {
    switch (action.type) {
        case NEWSLETTER_CREATE_REQUEST:
        case NEWSLETTER_LIST_REQUEST:
        case NEWSLETTER_DELETE_REQUEST:
        case NEWSLETTER_DELETE_ALL_REQUEST:
            return {
                ...state,
                loading: true,
                error: null,
                success: false
            };

        case NEWSLETTER_CREATE_SUCCESS:
            return {
                ...state,
                loading: false,
                success: true,
                newsletters: [...state.newsletters, action.payload.newsletter]
            };

        case NEWSLETTER_LIST_SUCCESS:
            return {
                ...state,
                loading: false,
                newsletters: action.payload
            };

        case NEWSLETTER_DELETE_SUCCESS:
            return {
                ...state,
                loading: false,
                success: true,
                newsletters: state.newsletters.filter(
                    (newsletter: { _id: string }) => newsletter._id !== action.payload
                )
            };

        case NEWSLETTER_DELETE_ALL_SUCCESS:
            return {
                ...state,
                loading: false,
                success: true,
                newsletters: []
            };

        case NEWSLETTER_CREATE_FAIL:
        case NEWSLETTER_LIST_FAIL:
        case NEWSLETTER_DELETE_FAIL:
        case NEWSLETTER_DELETE_ALL_FAIL:
            return {
                ...state,
                loading: false,
                error: action.payload,
                success: false
            };

        default:
            return state;
    }
};

export default newsletterReducer; 